// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32m0v","colMin":"styles_colMin__3_ReK"};